import React from 'react';

import EventEditForm from './EventEditForm';
import { Event } from '../../../Data/Classes';

function EventCreatePage(props) {
    const event = new Event(0, "", "", new Date(), "", "", 100, new Date(), new Date(), 3500, false, 0, new Date(), 1, true, false, false, false);

    return (
        <>
            <h1>Rendezvény létrehozása</h1>
            <EventEditForm event={event} />
        </>
    );
}

export default EventCreatePage;
